import { render } from "./CustomHyperlink.vue?vue&type=template&id=5a76c2da&scoped=true"
import script from "./CustomHyperlink.vue?vue&type=script&lang=js"
export * from "./CustomHyperlink.vue?vue&type=script&lang=js"

import "./CustomHyperlink.vue?vue&type=style&index=0&id=5a76c2da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a76c2da"]])

export default __exports__